<template>
  <div class="club-footer">
    <div class="dFlex pad5t pad5b blue-bg textCenter">
      <div class="club-footer-link">
        <a :href="`/Club?token=${getToken}`">
          <div class="menu-right-box colorWhite">محصولات</div>
        </a>
      </div>
      <div class="club-footer-link">
        <a :href="`/Prize?token=${getToken}`">
          <div class="menu-right-box colorWhite">جایزه‌های دریافتی</div>
        </a>
      </div>
      <div class="club-footer-link">
        <a :href="`/ScoreDetail?token=${getToken}`">
          <div class="menu-left-box colorWhite">تاریخچه</div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ClubFooter",
  computed: {
    ...mapGetters(["getToken"]),
  },
  mounted: function () {
    if (this.$route.query.token) {
      this.setToken(this.$route.query.token);
    }
  },
  methods: {
    ...mapActions(["setToken"]),
  },
};
</script>
<style scoped>
.club-footer {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  width: 100%;
  z-index: 1;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 760px;
  display: block;
  position: relative;
  margin-top: 40px;
}

.club-footer > div:first-child {
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.footer-right-box {
  border-left: 1px solid;
  padding: 10px;
}

.footer-left-box {
  padding: 10px;
}

a {
  color: #fff;
}

@media all and (max-width: 760px) {
  .club-footer {
    width: 100%;
  }
}

.club-footer .router-link-active {
  background: white !important;
  display: block;
  border-radius: 10px;
}

.club-footer .router-link-active .colorWhite {
  color: #09389f !important;
}

.club-footer-link {
  margin: 0 5px;
}

.club-footer-link .colorWhite {
  padding: 5px 10px;
}
</style>